module.exports = __webpack_public_path__ + "static/img/video_attributes.0fffb6cb.png";